import React from 'react';
import { actionsUsers } from 'helpers/utils';
import { useMeasureStore } from 'services/map/measure.context';
import { useColorsContext } from 'services/color.context';
import { useShapeStore } from 'services/map/shapes.context';
import * as S from '../ControlButton/styles';
import ListModal from './ListModal';

function Measure() {
	const { resetInteraction, showModalMeasure, setShowModalMeasure } = useMeasureStore();
	const { showModal, setShowModal } = useColorsContext();
	const { showModalDraw, setShowModalDraw, resetInteraction: resetInteractionDraw } = useShapeStore();

	const actionButton = !showModal ? 'abrir' : 'fechar';

	const openModal = () => {
		if (showModalDraw) {
			setShowModalDraw(false);
			resetInteractionDraw();
		}
		if (showModal) {
			setShowModal(false);
		}
		if (showModalMeasure) {
			resetInteraction();
		}
		setShowModalMeasure(!showModalMeasure);
		setShowModal(false);
		actionsUsers({
			category: `plataforma/mapa/webgis`,
			action: `Click no botão ${actionButton}`,
			label: 'Medir'
		});
	};

	return (
		<S.Container style={{ position: 'relative' }}>
			<S.ButtonControl
				type="button"
				data-title="Medir"
				className={showModalMeasure ? `active sm__tooltip` : `sm__tooltip`}
				onClick={openModal}
			>
				<svg width="22" height="22" viewBox="0 0 59 52" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 52H0V40L12 52Z" fill="#69625D" />
					<path
						d="M58.4426 36.5964L22.4244 0.580374C22.2363 0.393728 22.0129 0.24632 21.7673 0.146709C21.5217 0.0470981 21.2587 -0.00273099 20.9937 0.000115415C20.4736 0.00226482 19.9748 0.206795 19.603 0.57037L8.55744 11.6553C8.19974 12.0279 8 12.5244 8 13.0409C8 13.5574 8.19974 14.0539 8.55744 14.4265L44.5756 50.4426C44.9482 50.8003 45.4447 51 45.9613 51C46.4778 51 46.9743 50.8003 47.347 50.4426L58.4426 39.3677C58.8003 38.995 59 38.4985 59 37.982C59 37.4655 58.8003 36.969 58.4426 36.5964V36.5964ZM46.0063 46.1807L12.8396 13.0459L20.9937 4.85228L23.9952 7.85361L21.9942 9.85451C21.8079 10.042 21.7033 10.2955 21.7033 10.5598C21.7033 10.8241 21.8079 11.0777 21.9942 11.2651C22.0869 11.3597 22.1974 11.4349 22.3193 11.4864C22.4412 11.5379 22.5722 11.5647 22.7046 11.5653C22.8369 11.5647 22.9679 11.5379 23.0898 11.4864C23.2118 11.4349 23.3223 11.3597 23.4149 11.2651L25.4159 9.26424L27.7971 11.6453L24.2954 15.1369C24.0138 15.4161 23.8215 15.7728 23.7431 16.1615C23.6646 16.5502 23.7034 16.9535 23.8545 17.3201C24.0057 17.6868 24.2624 18.0002 24.5921 18.2207C24.9217 18.4412 25.3095 18.5587 25.7061 18.5584C25.9701 18.5586 26.2316 18.5065 26.4754 18.4052C26.7193 18.3039 26.9406 18.1554 27.1268 17.9681L30.6386 14.5066L34.0003 17.8381L31.9992 19.839C31.8129 20.0264 31.7083 20.28 31.7083 20.5443C31.7083 20.8086 31.8129 21.0621 31.9992 21.2496C32.0919 21.3441 32.2024 21.4193 32.3243 21.4708C32.4463 21.5224 32.5772 21.5492 32.7096 21.5497C32.842 21.5492 32.9729 21.5224 33.0949 21.4708C33.2168 21.4193 33.3273 21.3441 33.42 21.2496L35.421 19.2487L38.3024 22.13L34.3004 26.1318C34.0188 26.411 33.8266 26.7677 33.7481 27.1564C33.6696 27.5451 33.7084 27.9484 33.8596 28.315C34.0107 28.6817 34.2674 28.9951 34.5971 29.2156C34.9268 29.4361 35.3145 29.5536 35.7111 29.5533C35.9752 29.5535 36.2366 29.5014 36.4805 29.4001C36.7243 29.2988 36.9457 29.1503 37.1318 28.963L41.1338 24.9612L44.0053 27.8425L42.0043 29.8434C41.8179 30.0309 41.7133 30.2844 41.7133 30.5487C41.7133 30.813 41.8179 31.0666 42.0043 31.254C42.0969 31.3486 42.2074 31.4238 42.3294 31.4753C42.4513 31.5268 42.5823 31.5536 42.7146 31.5542C42.847 31.5536 42.978 31.5268 43.0999 31.4753C43.2218 31.4238 43.3323 31.3486 43.425 31.254L45.426 29.2531L48.3075 32.1344L44.3054 36.1362C44.0239 36.4155 43.8316 36.7721 43.7531 37.1609C43.6746 37.5496 43.7134 37.9529 43.8646 38.3195C44.0158 38.6861 44.2725 38.9996 44.6021 39.2201C44.9318 39.4405 45.3196 39.5581 45.7161 39.5577C45.9802 39.5579 46.2417 39.5059 46.4855 39.4046C46.7293 39.3033 46.9507 39.1547 47.1369 38.9675L51.1389 34.9657L54.1404 37.967L46.0063 46.1807Z"
						fill="#291F17"
					/>
				</svg>
			</S.ButtonControl>
			<ListModal />
		</S.Container>
	);
}

export default Measure;
